import './components/calculators/format';
import './components/calculators/input';

// =====================================================================
//  ASB (Amanah Saham Bumiputera) — growth projection
//  Static markup lives in page-calculator-asb.php.
// =====================================================================
(function () {
  const fmt = Calc.format;

  // ASB growth math — kept local (finance.js is for SHARED formulas only).
  // Mirrors ASNB's own compound-periodic calculator so our figures agree with
  // the fund manager's: the quoted rate is a NOMINAL rate compounded `perYear`
  // times, converted to an effective annual rate and then to an effective
  // MONTHLY rate; the monthly contribution is deposited at the START of each
  // month, so it earns that month's growth too.
  //   c = (1 + rate/perYear)^perYear - 1      effective annual
  //   n = (1 + c)^(1/12) - 1                  effective monthly
  //   each month: balance = (balance + monthly) × (1 + n)
  // Yearly rows are the monthly steps aggregated over each 12-month block.
  function projectASB(initial, monthly, ratePct, years, perYear) {
    const a = perYear || 1;
    const c = Math.pow(1 + (ratePct || 0) / 100 / a, a) - 1;
    const n = Math.pow(1 + c, 1 / 12) - 1;
    const months = Math.round((years || 0) * 12);
    const contrib = monthly || 0;

    let balance = initial || 0;
    let totalDividends = 0;
    const schedule = [];
    let begin = balance, yearDividend = 0, yearContrib = 0;

    for (let m = 1; m <= months; m++) {
      const dividend = (balance + contrib) * n;
      balance = balance + contrib + dividend;
      totalDividends += dividend;
      yearDividend += dividend;
      yearContrib  += contrib;
      if (m % 12 === 0) {
        schedule.push({ year: m / 12, begin, contrib: yearContrib, dividend: yearDividend, end: balance });
        begin = balance; yearDividend = 0; yearContrib = 0;
      }
    }
    const totalInvested = (initial || 0) + contrib * months;
    return { futureValue: balance, totalInvested, totalDividends, schedule };
  }

  const REF_RATES = [4, 5, 6, 7];
  // Period columns are read from the table's own <th data-period> so the axis
  // can never drift out of sync with the rendered headers.
  const refPeriods = () =>
    [...document.querySelectorAll('.ref-grid thead th[data-period]')].map(th => +th.dataset.period);

  const state = {
    initial: 10000,
    monthly: 500,
    rate: 5.0,
    period: 10,
    compounding: 1,   // compounds per year: 1 annually | 2 semi-annually | 4 quarterly
    activeTab: 'breakdown',
  };

  const setText = (id, val) => {
    const el = document.getElementById(id);
    if (el) el.textContent = val;
  };
  const syncInput = (id, val) => Calc.input.syncValue(id, val);

  function updateStatBand() {
    const p = projectASB(state.initial, state.monthly, state.rate, state.period, state.compounding);
    const totalReturn = p.totalInvested > 0 ? (p.totalDividends / p.totalInvested) * 100 : 0;
    setText('asb-stat-fv',        fmt.money(p.futureValue, 0));
    setText('asb-stat-invested',  fmt.money(p.totalInvested, 0));
    setText('asb-stat-dividends', fmt.money(p.totalDividends, 0));
    setText('asb-stat-return',    `${totalReturn.toFixed(1)}%`);
  }

  function updateYearTable() {
    const tbody = document.getElementById('asb-year-tbody');
    if (!tbody) return;
    const p = projectASB(state.initial, state.monthly, state.rate, state.period, state.compounding);
    tbody.innerHTML = p.schedule.map(row => (
      `<tr>` +
        `<td>${row.year}</td>` +
        `<td>${fmt.money(row.begin)}</td>` +
        `<td>${fmt.money(row.contrib)}</td>` +
        `<td>${fmt.money(row.dividend)}</td>` +
        `<td>${fmt.money(row.end)}</td>` +
      `</tr>`
    )).join('');
    setText('asb-ft-contrib',  fmt.money(state.monthly * 12 * state.period));
    setText('asb-ft-dividend', fmt.money(p.totalDividends));
    setText('asb-ft-end',      fmt.money(p.futureValue));
  }

  function updateReferenceGrid() {
    const tbody = document.getElementById('asb-grid-tbody');
    if (!tbody) return;
    const periods = refPeriods();
    tbody.innerHTML = REF_RATES.map(rate => {
      const isHighRow = rate === Math.round(state.rate);
      const cells = periods.map(years => {
        const fv = projectASB(state.initial, state.monthly, rate, years, state.compounding).futureValue;
        const isHighCol = years === state.period;
        return `<td class="${isHighCol ? 'highlight-col' : ''}">${fmt.number(fv, 0)}</td>`;
      }).join('');
      return `<tr class="${isHighRow ? 'highlight' : ''}"><th>${rate}%</th>${cells}</tr>`;
    }).join('');
  }

  function refresh() {
    syncInput('asb-initial-input', state.initial);
    syncInput('asb-monthly-input', state.monthly);
    syncInput('asb-period-input',  state.period);
    syncInput('asb-rate-input',    state.rate.toFixed(2));
    syncInput('asb-compounding-input', state.compounding);

    updateStatBand();
    if (state.activeTab === 'breakdown') updateYearTable();
    else updateReferenceGrid();
  }

  function activateTab(tabId) {
    state.activeTab = tabId;
    document.querySelectorAll('#asb-tabs .btn-tab').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabId);
    });
    document.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.toggle('d-none', panel.id !== `asb-tab-${tabId}`);
    });
    if (tabId === 'breakdown') updateYearTable();
    else updateReferenceGrid();
  }

  function bindEvents() {
    ['input', 'change'].forEach(evt => document.addEventListener(evt, (e) => {
      const id = e.target.id;
      const v = Calc.input.getValue(e.target);
      if (id === 'asb-initial-input') { state.initial = v || 0;  refresh(); }
      if (id === 'asb-monthly-input') { state.monthly = v || 0;  refresh(); }
      if (id === 'asb-period-input')  { state.period  = v || 1;  refresh(); }
      if (id === 'asb-rate-input')    { state.rate    = v || 0;  refresh(); }
      if (id === 'asb-compounding-input') { state.compounding = v || 1; refresh(); }
    }));

    document.querySelectorAll('#asb-tabs .btn-tab').forEach(btn => {
      btn.addEventListener('click', () => activateTab(btn.dataset.tab));
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindEvents();
    refresh();
  });
})();
